<template>
    <div class="az-actions-form">
        <v-col md="6" class="pt-0 pb-0">
            <v-row>
              <slot name="esquerdo"></slot>
            </v-row>
        </v-col>
        <v-col md="6" class="pt-0 pb-0">
            <v-row class="align-end justify-end">
              <slot name="direito"></slot>
            </v-row>
        </v-col>
    </div>
</template>

<script>
    export default {
        name: 'AcoesFormulario',
    }
</script>

<style lang="stylus">
</style>
